import { loadingState } from "./loading";

export function loadingShow(opts = {}) {
  loadingState.counter += 1;
  loadingState.active = true;
  if (opts.text) loadingState.text = opts.text;
}

export function loadingHide() {
  loadingState.counter = Math.max(0, loadingState.counter - 1);
  if (loadingState.counter === 0) loadingState.active = false;
}
